// extracted by mini-css-extract-plugin
export default {"input":"ccJ3Ot","input--form":"VsESzE","inputForm":"VsESzE","input--empty":"tfT8rQ","inputEmpty":"tfT8rQ"};